export default {"src":"/_next/static/image/public/images/flags/flag_681.02b4a81d749f4eff39a138d2f95b5a06.svg","height":16,"width":24};